import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ILoginRequest } from '../../core/models';
import { UserService } from '../../core/services/user.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  title = 'SnapPayLoginUI';
  oldpwd: any = "";
  newpwd: any = "";
  
  constructor(private userService: UserService, private router: Router) { }

  ngOnInit() {
  }

  async ChangePassword() {
    if (!this.oldpwd) {
      alert("please enter the old password");
    }
    else if (!this.newpwd) {
      alert("please enter the new password");
    }
    else {
      if (confirm('Are you sure you want to change password?')) {
        const changePwdBody = {
          userName: this.userService.readUserObject.userName,
          oldPassword: this.oldpwd,
          newPassword: this.newpwd
        };
        await (await this.userService.ChangePassword(changePwdBody)).subscribe((r: any) => {
          if (r.errorMessage == "Success") {
            alert(r.errorMessage);
          } else {
            alert(r.errorMessage);
          }
        });
      }
    } 
  }
}
